export const getCurrentUserSelector = state => state.currentUser;
